<template lang="pug">
div
  h2 No show
  p Are you sure you wish to mark booking {{ booking.Number }} as No Show?
  .actions
    BriqButton.mr-XXS(variant="text" :disabled="loading" @click="close") Cancel
    BriqButton.ml-XXS(@click="onConfirm" :disabled="loading" variant='red') Mark as no-show
</template>

<script>
export default {
  name: 'NoShowDialog',
  props: {
    booking: Object
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async onConfirm() {
      this.loading = true
      const res = await this.$store.dispatch('bookings/markAsNoShow', this.booking.Key)
      if (res.status === 200) {
        this.$notifySuccess(`Booking ${this.booking.Number} has been marked as no-show.`)
        setTimeout(() => {
          this.loading = false
          this.close()
          this.$emit("reloadBookings")
        }, 2000);
      } else {
        this.$notifySuccess(`Unable to mark booking ${this.booking.Number} as no-show. Please try again later.`)
        this.loading = false
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus">
.actions
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 12px;
</style>